  import {Navbar} from 'src/components/UIComponents'
  import messages from './AppNavbar.json'

  export default {
    name: 'main-navbar',

    i18n: messages,
    
    components: {
      Navbar
    },

    data() {
      return {
        showMenu: false
      }
    }

  }